import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import clsx from "clsx";
import { useStyles } from "./Receipts.styles";

/**
 * Renders a receipt header or footer block.
 *
 * The supplied text is rendered as ESCAPED React text (React escapes string
 * children by default) — never via `dangerouslySetInnerHTML` — and is split on
 * newline characters into separate lines, matching the ValetReceiptDetails
 * pattern. The block is rendered only when the resolved text is present
 * (non-null and non-empty after trimming), so an absent header/footer leaves
 * no section at all (Requirements 3.1, 3.2, 3.6, 3.7).
 *
 * @param {object} props Component props.
 * @param {string} props.text The resolved header/footer text (already trimmed
 *   to null by the BFF when empty).
 * @param {"header"|"footer"} [props.variant] Which block this is, used for the
 *   test id only.
 */
const ReceiptHeaderFooter = ({ text, variant = "header" }) => {
  const classes = useStyles();

  if (text === null || text === undefined || text.trim() === "") {
    return null;
  }

  const lines = text.split("\n");

  return (
    <div
      className={clsx(classes.headerFooter, `receipt-${variant}`)}
      data-testid={`receipt-${variant}`}
    >
      {lines.map((line, index) => (
        <Typography key={index} variant="h6" gutterBottom>
          {line}
        </Typography>
      ))}
    </div>
  );
};

ReceiptHeaderFooter.propTypes = {
  text: PropTypes.string,
  variant: PropTypes.oneOf(["header", "footer"]),
};

export default ReceiptHeaderFooter;
